<app-header></app-header>
<div id="content">
    <div class="hero-wrap py-5">
        <div class="hero-mask opacity-7"></div>

        <!-- Slideshow Background -->
        <div class="hero-bg-slideshow owl-carousel">
            <div class="item">
              <div class="hero-bg"><img src="https://lccintl.ezeeibe.com/Offers/50 Counties_GNPEOO666ZWP_INFL-KK.jpeg"></div>
            </div>
            <div class="item">
              <div class="hero-bg"><img src="https://lccintl.ezeeibe.com/Offers/International Roaming Best Offers_NUOWOMZASHQD_INFL-KK.jpeg"></div>
            </div>
            <div class="item">
              <div class="hero-bg"><img src="https://lccintl.ezeeibe.com/Offers/Stay Connected_BHZNRAM74DB6_INFL-KK.jpeg"></div>
            </div>
            <div class="item">
                <div class="hero-bg"><img src="https://lccintl.ezeeibe.com/Offers/Student Plans_T52MSJ9HW5PV_INFL-KK.jpeg"></div>
              </div>
            </div>
        <!-- Slideshow Background End -->

        <div class="hero-content">
            <div class="container mt-2 pt-4 header_search">
            </div>
        </div>
    </div>
    <div id="content" class="bg-light shadow-md pt-3 pb-3">
        <div class="container mt-2">
            <div class="row">
                <div class="col-md-2 col-lg-2 text-4 mt-3">
                    <b>I am travelling to</b>
                </div>
                <div class="col-md-3 col-lg-3">
                    <select class="form-control ng-untouched ng-pristine ng-invalid text-3" [(ngModel)]="orgCnt"
                        name="orgCnt" required="true">
                        <option [selected]="true" value="">Select Country of Travel</option>
                        <option value='United Kingdom'>United Kingdom</option>
                        <option value='United States'>United States</option>
                        <option value='Canada'>Canada</option>
                        <option value='Switzerland'>Switzerland</option>
                        <option value='Thailand'>Thailand</option>
                        <option value='Australia'>Australia</option>
                        <option value='Austria'>Austria</option>
                        <option value='Belgium'>Belgium</option>
                        <option value='Bulgaria'>Bulgaria</option>
                        <option value='China'>China</option>
                        <option value='Croatia'>Croatia</option>
                        <option value='Cyprus'>Cyprus</option>
                        <option value='Czech Republic'>Czech Republic</option>
                        <option value='Denmark'>Denmark</option>
                        <option value='Estonia'>Estonia</option>
                        <option value='Finland'>Finland</option>
                        <option value='France'>France</option>
                        <option value='Georgia'>Georgia</option>
                        <option value='Germany'>Germany</option>
                        <option value='Greece'>Greece</option>
                        <option value='Hong Kong'>Hong Kong</option>
                        <option value='Hungary'>Hungary</option>
                        <option value='Iceland'>Iceland</option>
                        <option value='Indonesia'>Indonesia</option>
                        <option value='Ireland'>Ireland</option>
                        <option value='Italy'>Italy</option>
                        <option value='Latvia'>Latvia</option>
                        <option value='Liechtenstein'>Liechtenstein</option>
                        <option value='Lithuania'>Lithuania</option>
                        <option value='Luxembourg'>Luxembourg</option>
                        <option value='Malaysia'>Malaysia</option>
                        <option value='Malta'>Malta</option>
                        <option value='Mexico'>Mexico</option>
                        <option value='Myanmar'>Myanmar</option>
                        <option value='Netherlands'>Netherlands</option>
                        <option value='New Zealand'>New Zealand</option>
                        <option value='Norway'>Norway</option>
                        <option value='Poland'>Poland</option>
                        <option value='Portugal'>Portugal</option>
                        <option value='Romania'>Romania</option>
                        <option value='Russian Federation'>Russian Federation</option>
                        <option value='Singapore'>Singapore</option>
                        <option value='Slovakia'>Slovakia</option>
                        <option value='Slovenia'>Slovenia</option>
                        <option value='South Africa'>South Africa</option>
                        <option value='South Korea'>South Korea</option>
                        <option value='Spain'>Spain</option>
                        <option value='Sri Lanka'>Sri Lanka</option>
                        <option value='Sweden'>Sweden</option>
                        <option value='Viet Nam'>Viet Nam</option>

                    </select>
                </div>
                <div class="col-md-4 col-lg-4">
                    <div class="mb-1" style="margin-left: 15px">
                        <div class="custom-control custom-radio custom-control-inline onewayfo">
                            <input id="recharge" [(ngModel)]="activation" value="activation" name="flight-trip"
                                class="custom-control-input" required type="radio" (click)="enableActivation()">
                            <label class="custom-control-label text-4" for="recharge"><strong>New SIM / Activation</strong></label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline onewayfo">
                            <input [(ngModel)]="activation" value="recharge" id="newsim" name="flight-trip"
                                class="custom-control-input " checked="" required type="radio" (click)="enableActivation()">
                            <label class="custom-control-label text-4" for="newsim"><strong>Recharge</strong></label>
                        </div>
                    </div>
                </div>
            </div>
            <app-banner></app-banner>
            <div class="row" *ngIf="orgCnt !='' && activation !=''">
                <div class="row">
                    <h4 class="text-center mt-2 ml-5"><b>Voice, SMS, Data</b></h4>
                </div>
                <div class="col-md-12 col-sm-12 row">
                    <div class="col-md- col-sm-3 data-box mt-4" *ngFor="let Agent of rechargelist;let i = index">
                        <div>
                            <h4 class="text-center">{{Agent.service.split('@')[0]}}</h4>
                        </div>
                        <p class="paragraf-coll">₹ {{Agent.price}}</p>

                        <div class="content">
                            <div class="text list-icons">
                                <ul class="list united-kingdom">
                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Plan Type</strong>
                                        <span style="float: right;" class="plan-type">Prepaid&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Local | India Minutes</strong>
                                        <span style="float: right;"
                                            class="local-india-minutes">{{Agent.voice}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>High Speed Data</strong>
                                        <span style="float: right;"
                                            class="high-speed-data">{{Agent.data}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>SMS Local</strong>
                                        <span style="float: right;" class="sms-local">{{Agent.sms}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Incoming Calls</strong>
                                        <span style="float: right;" class="incoming-calls">Unlimited&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Validity Days</strong>
                                        <span style="float: right;" class="validity-days">{{Agent.validityDays}}
                                            Days&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Countries Covered</strong>
                                        <span style="float: right;"
                                            class="countries-covered">{{orgCnt}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li class="mb-1 text-2">
                                        <span style="float: right;" class="countries-covered"><button
                                                class="btn btn-primary btn-block" target="_top"
                                                (click)="ProceedRecharge(Agent)" type="submit">Buy</button>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="orgCnt !='' && activation !=''">
                <div class="row">
                    <h4 class="text-center mt-2 ml-5"><b>Only Data</b></h4>
                </div>
                <div class="row">
                    <div class="data-box ml-4 mt-4" *ngFor="let Agent of rechargelistData;let i = index">
                        <div>
                            <h4 class="text-center">{{Agent.service.split('@')[0]}}</h4>
                        </div>
                        <p class="paragraf-coll">₹ {{Agent.price}}</p>

                        <div class="content">
                            <div class="text list-icons">
                                <ul class="list united-kingdom">
                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Plan Type</strong>
                                        <span style="float: right;" class="plan-type">Prepaid&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Local | India Minutes</strong>
                                        <span style="float: right;"
                                            class="local-india-minutes">{{Agent.voice}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>High Speed Data</strong>
                                        <span style="float: right;"
                                            class="high-speed-data">{{Agent.data}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>SMS Local</strong>
                                        <span style="float: right;" class="sms-local">{{Agent.sms}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Incoming Calls</strong>
                                        <span style="float: right;" class="incoming-calls">Unlimited&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Validity Days</strong>
                                        <span style="float: right;" class="validity-days">{{Agent.validityDays}}
                                            Days&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>

                                    <li class="mb-1"><i class="fa fa-check-circle"
                                            style="color: #575455;"></i>&nbsp;&nbsp;
                                        <strong>Countries Covered</strong>
                                        <span style="float: right;"
                                            class="countries-covered">{{orgCnt}}&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li class="mb-1 text-2">
                                        <span style="float: right;" class="countries-covered"><button
                                                class="btn btn-primary" target="_top" (click)="ProceedRecharge(Agent)"
                                                type="submit">Buy</button>
                                        </span>
                                        <!-- <span class="countries-covered"><button
                                                class="btn btn-primary" target="_top"
                                                (click)="ProceedRecharge(Agent)" type="submit">Topup</button>
                                        </span>
                                        <span class="countries-covered"><button
                                                class="btn btn-primary" target="_top"
                                                (click)="ProceedRecharge(Agent)" type="submit">Activate SIM</button>
                                        </span> -->
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Exlcusive Deals Start-->
    <!-- <section class="section exlcusive_deals" *ngIf="esimDeals.length > 0">
        <div class="container">
            <div class="home_heading">
                <div class="left">
                    <h2 class="">eSIM <strong>Deals</strong></h2>
                </div>
            </div>
            <div class="owl-carousel owl-theme banner">
                <div class="item" *ngFor="let ed of esimDeals">
                    <div class="card">
                        <div class="imgsection"> <img class="card-img-top hightsim" src={{ed.ImageURL}}
                                alt="{{ed.Title}}">
                        </div>
                        <div class="card-body">
                            <div class="label">
                                <p>{{ed.Title}}</p>
                            </div>
                            <div class="itemDesc">
                                <h5 class="card-title">{{ed.Title}}</h5>
                                <p>{{ed.Description}}</p>
                            </div>
                            <div class="bookingsection">
                                <a href="{{ed.ExternalURL}}" target="_blank">Book Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- Exlcusive Deals End-->
    <app-footer></app-footer>
</div>